module.exports = __webpack_public_path__ + "img/hr-car-6.8724e644.png";